import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18.558}
      height={16.985}
      viewBox="0 0 18.558 16.985"
      {...props}
    >
      <g data-name="Group 1313">
        <path
          data-name="Path 5029"
          d="M12.379 2.999H7.035a.334.334 0 00-.357.23 2.269 2.269 0 01-4.127 0 .328.328 0 00-.359-.227c-.459.014-.919.008-1.378 0a.73.73 0 110-1.451c.459-.005.919-.009 1.378 0a.33.33 0 00.363-.222 2.268 2.268 0 014.126-.006.335.335 0 00.358.229q5.319-.009 10.639 0c.461 0 .733.164.844.5a.716.716 0 01-.579.936 2.2 2.2 0 01-.314.014zm-8.588-.76a.829.829 0 00.8.863.829.829 0 10-.8-.863z"
        />
        <path
          data-name="Path 5030"
          d="M.929 9.218a2.2 2.2 0 01-.314-.014.716.716 0 01-.579-.936c.111-.339.383-.5.844-.5h10.639a.335.335 0 00.358-.229 2.268 2.268 0 014.126.006.33.33 0 00.363.222c.459-.012.919-.008 1.378 0a.73.73 0 110 1.451c-.459 0-.919.01-1.378 0a.329.329 0 00-.359.227 2.269 2.269 0 01-4.127 0 .334.334 0 00-.357-.23c-1.781.008-3.562 0-5.343 0zm12.993-1.554a.829.829 0 10.045 1.657.829.829 0 00-.045-1.657z"
        />
        <path
          data-name="Path 5031"
          d="M13.92 15.439h-3.8a.3.3 0 00-.325.2 2.27 2.27 0 01-4.148 0 .3.3 0 00-.326-.2q-2.2.008-4.4 0a1.8 1.8 0 01-.36-.027.717.717 0 01.04-1.409 2.037 2.037 0 01.313-.016h4.4a.318.318 0 00.338-.221 2.272 2.272 0 014.14 0 .317.317 0 00.34.216q3.748-.009 7.5 0c.583 0 .922.264.927.719s-.344.734-.939.734zm-7.022-.734a.828.828 0 00.823.836.829.829 0 00.013-1.658.824.824 0 00-.836.822z"
        />
      </g>
    </svg>
  );
}

export default SvgComponent;
